import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ObtenerSocios from '../functions/ObtenerSocios';
import SocioTabla from '../types/SocioTabla';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import axios from 'axios';

interface ListarSociosProps {
    defaultItemsPerPage?: number;
    handleEditSocio: (socio: SocioTabla) => void;
    handleDeleteSocio: (socio: SocioTabla) => void;
    handleMostrarCredencial: (socio: SocioTabla) => void;
}

export const ListarSocios: React.FC<ListarSociosProps> = ({ defaultItemsPerPage = 15, handleEditSocio, handleDeleteSocio, handleMostrarCredencial }) => {
  
  const [socios, setSocios] = useState<SocioTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const handleUbication = (socio: SocioTabla) => {
    console.log('Mostrar ubicacion', socio);
  };

  useEffect(() => {
    const fetchSocios = async () => {
      try {
        const data = await ObtenerSocios();
        setSocios(data.socios);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los socios');
        setLoading(false);
      }
    };

    fetchSocios();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'right' as const },
    { key: 'documento', label: 'DOCUMENTO', align: 'center' as const },
    { key: 'apeynom', label: 'APELLIDO Y NOMBRES', align: 'left' as const },
    { key: 'sexo', label: 'SEXO', align: 'left' as const },
    { key: 'tiposocio', label: 'TIPO', align: 'left' as const },
    { key: 'origen', label: 'ORIGEN', align: 'left' as const },
    { key: 'doctitular', label: 'TITULAR', align: 'right' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dadobaja', label: 'BAJA', align: 'center' as const },
  ];

  const handleEdit = (socio: SocioTabla) => {
    handleEditSocio(socio);
  };

  const handlePadronDownload = async () => {

    const remoteUrl = 'https://endpoints.mapsys.com.ar/gestion/obtener_padron_socios';

    try {
      
      const response = await axios.post(
            remoteUrl,
            { 
              "usuario": "mpatti",
              "clave": "all2GetHer_!",
              "modo": "con_suscripciones"
            }, // Datos en `data`
            {
                responseType: "blob", // Se coloca en la configuración (headers)
            }
        );

        // Obtener el nombre de archivo desde los headers
        const contentDisposition = response.headers["content-disposition"];

        let fileName = "archivo.xlsx"; // Nombre por defecto

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+?)"?$/);
            if (match) fileName = match[1];
        }

        // Crear un objeto URL y descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Usa el nombre enviado desde Python
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error al descargar el archivo:", error);
    }
  };


  const handlePadronFullDownload = async () => {

    const remoteUrl = 'https://endpoints.mapsys.com.ar/gestion/obtener_padron_socios';

    try {
      
      const response = await axios.post(
            remoteUrl,
            { 
              "usuario": "mpatti",
              "clave": "all2GetHer_!",
              "modo": "completo"
            }, // Datos en `data`
            {
                responseType: "blob", // Se coloca en la configuración (headers)
            }
        );

        // Obtener el nombre de archivo desde los headers
        const contentDisposition = response.headers["content-disposition"];

        let fileName = "archivo.xlsx"; // Nombre por defecto

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+?)"?$/);
            if (match) fileName = match[1];
        }

        // Crear un objeto URL y descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Usa el nombre enviado desde Python
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error al descargar el archivo:", error);
    }
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center">
        <h1 className="font-metropolis text-xl font-bold mb-2">Socios cargados</h1>
        <button className="vp-btn-azul-sm shadow-md shadow-vp-gris mb-2" onClick={handlePadronDownload}><FileDownloadIcon className="mr-1" fontSize="small"/>Descargar Padrón de Socios con Suscripciones</button>
        <button className="vp-btn-verde-sm shadow-md shadow-vp-gris mb-2" onClick={handlePadronFullDownload}><FileDownloadIcon className="mr-1" fontSize="small"/>Descargar Padrón Completo de Socios</button>
      </div>
      <Tabla columns={columns} data={socios} onEdit={handleEdit} onDelete={handleDeleteSocio} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbication} acciones={['editar','credencial']}/>
    </div>
  );
};